import React from 'react';

const ExactSearch = (props) => {
  return <div>Exact Search Page</div>;
};

export default ExactSearch;
